import { SatellitePage } from "../SatellitePage";

export default class HomeSatellitePage extends SatellitePage {
    public $video: JQuery;
    public video: HTMLVideoElement;

    private started2 = false;
    private timer = null;

    public onInit(): void {
        this.$video = $('.satellite-home__video', this.$el);

        if (this.$video.length) {
            this.video = <HTMLVideoElement> $('video', this.$video)[0];

            const $mute = $('.satellite-home__mute', this.$video);

            $mute.on('click', (e) => {
                this.video.muted = !this.video.muted;

                this.$video.toggleClass('satellite-home__video--laud', !this.video.muted);
            });
        }
    }

    private startTimer(): void {
        if (this.timer != null) {
            return;
        }

        this.timer = setTimeout(() => {
            this.$video.fadeIn();
            this.video.play();

            this.started2 = true;

            this.$el.addClass('satellite-home--started');
        }, 4000);
    }

    public onStart(): void {
        this.startTimer();
    }

    public onBlur(): void {
        this.video.pause();

        if (this.timer != null) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    public onFocus(): void {
        super.onFocus();

        if (this.started2) {
            this.video.play();
        } else {
            this.startTimer();
        }
    }
}
